module.exports = __webpack_public_path__ + "static/media/nexthink-whiteout.6f6d05f9.svg";